<template>
  <div class="home">
    <div class="topblock"></div>
    <img class="topimg" src="@/assets/healthylife.png" alt="" />
    <!-- <p class="title">药联健康</p>
    <p class="subtitle">专业有温度的健康平台</p>
    <img class="middleimg" src="@/assets/uniondrug_phone.png" alt="" /> -->

    <div class="bottomBar">
      <div class="download">
        <img
          class="downloadimg"
          v-clipboard:copy="copyText"
          src="@/assets/downloadimg1.png"
          alt=""
          @click="gotodownload"
          v-if="(isIOS || isWX) && !canOpen"
        />

        <!-- 打开app -->
        <img
          class="downloadimg"
          v-clipboard:copy="copyText"
          src="@/assets/openapp1.png"
          alt=""
          @click="gotodownload"
          v-if="(isIOS || isWX) && canOpen"
        />
      </div>

      <a
        v-if="!isIOS && !isWX"
        :href="androidUrl"
        download="药联健康"
        v-clipboard:copy="copyText"
      >
        <img class="downloadimg" src="@/assets/downloadimg1.png" alt="" />
      </a>
    </div>
    <div class="browser" v-if="show">
      <img class="image1" src="@/assets/箭头.png" alt="" />
      <div class="text1">
        <span>请点击右上角</span>
        <div class="text2">
          选择<img class="image2" src="@/assets/地球.png" alt="" />在浏览器打开
        </div>
      </div>
    </div>

    <wx-open-launch-app
      id="launch-btn"
      appid="wx3bd1a20ffcb1db00"
      :extinfo="copyText"
      @launch="handleLaunchFn"
      @error="handleErrorFn"
      class="downloadOpenApp"
      v-if="(isIOS || isWX) && canOpen"
    >
      <script type="text/wxtag-template">
        <style>.btn {width: 100vw; height: 51px; text-align: center;}</style>
        <div class="btn"></div>
      </script>
    </wx-open-launch-app>
  </div>
</template>

<script>
import Vue from "vue";
// import axios from 'axios'
export default {
  name: "HealthyLife",
  components: {},
  data() {
    return {
      show: false,
      isIOS: true,
      isWX: false,
      canOpen: false,
      androidUrl: "",
      copyText: "",
      iosUrl: "https://itunes.apple.com/cn/app/id1500372554?mt=8",
    };
  },
  created: function () {
    //配置微信
    window.udwxconfig(() => {
      this.canOpen = true;
    });
    // document.title = "药联健康";
    this.isIOS = this.getIsIosClient();
    this.isWX = this.getIsWxClient();
    let that = this;
    Vue.axios
      .post(window["domain"] + "/common/getDownLoadUrl")
      .then((response) => {
        if (response.data.data && response.data.data.url) {
          that.androidUrl = response.data.data.url;
          console.log(response.data.data.url);
        }
      });
    if (window["channel"]) {
      this.copyText = `###***title=药联健康&channel=${window["channel"]}***###`;
    }
  },
  mounted() {
    this.$trackFn.view("$pageView", {
      page_type: "app_download_page",
    });
  },
  methods: {
    handleLaunchFn() {},
    handleErrorFn() {
      this.canOpen = false;
      this.gotodownload();
    },
    gotodownload() {
      if (!this.isIOS) {
        this.show = true;
      } else {
        window.open(this.iosUrl);
      }
    },
    getIsWxClient() {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      }
      return false;
    },
    getIsIosClient() {
      var u = navigator.userAgent;
      // console.log('来了',u)
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        // console.log('安卓')
        return false;
      }
      if (isiOS) {
        // console.log('ios')
        return true;
      }
    },
  },
};
</script>

<style scoped>
.bottomBar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 0.68rem;
  background-color: #00b095;
  margin: 0 0;
  padding: 0 0;
  font-size: 0;

  display: flex;
  align-items: center;
  justify-content: center;
}
.home {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: #00b095;
  /* background-image: linear-gradient(#ffffff, #00b095); */
}
.topblock {
  height: 0.14rem;
  background-color: #ffffff;
}
.topimg {
  margin-top: -0.01rem;
  /* height: 5.8rem; */
  width: 100%;
  background-image: linear-gradient(#ffffff, #00b095);
}

p {
  text-align: center;
}

.title {
  font-size: 0.3rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 0.42rem;
  text-align: center;
  margin: 0.22rem 0 0 0;
}

.subtitle {
  font-size: 0.15rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 0.21rem;
  margin: 0.08rem 0 0 0;
}

.middleimg {
  width: 100%;
  margin-top: 0.37rem;
}

.download {
  /* position: fixed;
  bottom: 0.12rem;
  left: 0.36rem;
  right: 0.36rem;
  height: 0.51rem; */
  /* width: 3.04rem; */

  /* display: flex;
  align-items: center;
  justify-content: center; */
  padding: 0 0;
  margin: 0 0;
}

.downloadimg {
  /* position: absolute; */
  height: 0.44rem;
  margin: 0.12rem 0.16rem;
  /* width: 3.04rem; */
}

.downloadOpenApp {
  z-index: 1000000000;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 0.68rem;
}

a {
  /* position: fixed;
  bottom: 0.12rem;
  left: 0.36rem;
  right: 0.36rem;
  height: 0.51rem; */

  display: flex;
  align-items: center;
  justify-content: center;
}

.browser {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: #000000;
  opacity: 0.7;
}

.browser .image1 {
  position: absolute;
  right: 0.32rem;
  top: 0.09rem;
  width: 0.64rem;
  height: 0.66rem;
}

.text1 {
  position: absolute;
  right: 0rem;
  left: 0rem;
  top: 0.63rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  font-size: 0.18rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 0.25rem;
}
.text2 {
  margin-top: 0.07rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.browser .image2 {
  width: 0.18rem;
  height: 0.18rem;
  margin-left: 0.03rem;
  margin-right: 0.03rem;
}
</style>